import { useEffect } from "react";

/**
 * Injects/updates document.head meta tags + JSON-LD scripts per route.
 * Cleans up on unmount.
 */
export default function Seo({
  title,
  description,
  canonical,
  ogImage,
  jsonLd = [],
}) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
        document.head.appendChild(el);
      } else {
        Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
      }
      return el;
    };

    if (description) {
      setMeta('meta[name="description"]', { name: "description", content: description });
      setMeta('meta[property="og:description"]', { property: "og:description", content: description });
      setMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    }
    if (title) {
      setMeta('meta[property="og:title"]', { property: "og:title", content: title });
      setMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    }
    if (ogImage) {
      setMeta('meta[property="og:image"]', { property: "og:image", content: ogImage });
    }
    if (canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
      setMeta('meta[property="og:url"]', { property: "og:url", content: canonical });
    }

    // JSON-LD blocks
    const scripts = [];
    (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).forEach((obj, i) => {
      if (!obj) return;
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.dataset.seoId = `seo-jsonld-${i}`;
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      scripts.push(s);
    });

    return () => {
      scripts.forEach((s) => s.parentNode && s.parentNode.removeChild(s));
    };
  }, [title, description, canonical, ogImage, JSON.stringify(jsonLd)]);

  return null;
}
